/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Container, Step, stepIconClasses, StepLabel, stepLabelClasses, Stepper } from "@mui/material";
import StripeElements from "../../../../Basis/Components/StripeElements";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nEinstellungen";
import { Schritt, SCHRITTE } from "../../Queries/Schnelleinstieg";
import SchnelleinstiegBranding from "./SchnelleinstiegBranding";
import { useSchnelleinstiegContext } from "./SchnelleinstiegContext";
import SchnelleinstiegFinanzeinstellungen from "./SchnelleinstiegFinanzeinstellungen";
import SchnelleinstiegFirmendaten from "./SchnelleinstiegFirmendaten";
import SchnelleinstiegStripe from "./SchnelleinstiegStripe";
import SchnelleinstiegZahlungsmethode from "./SchnelleinstiegZahlungsmethode";

export default function SchnelleinstiegSchritte() {
    const { aktuellerSchritt } = useSchnelleinstiegContext();
    const { t } = useTranslation();
    return (
        <Container
            maxWidth="sm"
            sx={{
                margin: "auto",
                py: 2,
                flex: 1,
            }}
        >
            <Stepper
                sx={{
                    mb: "34.39px"// korrigiert die falsche Ausrichtung verursacht durch den leeren Tooltip
                }}
                activeStep={aktuellerSchritt}
                alternativeLabel
            >
                {SCHRITTE.map(schritt => {
                    return (
                        <Step key={schritt}>
                            <StepLabel
                                sx={{
                                    [`& .${stepLabelClasses.label}.${stepLabelClasses.completed}`]: {
                                        color: "rgba(0, 0, 0, 0.54)",
                                        fontWeight: 400,
                                    },

                                    [`& .${stepIconClasses.root}.${stepIconClasses.completed}`]: {
                                        color: "success.dark",
                                    },
                                }}
                            >
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: t(translationKeys.schnelleinstiegSchritte.schritt[schritt])
                                    }}
                                />
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {(() => {
                switch (aktuellerSchritt) {
                    case Schritt.firmendaten:
                        return <SchnelleinstiegFirmendaten />
                    case Schritt.finanzeinstellungen:
                        return <SchnelleinstiegFinanzeinstellungen />
                    case Schritt.branding:
                        return <SchnelleinstiegBranding />
                    case Schritt.zahlungsmethode:
                        return <StripeElements><SchnelleinstiegZahlungsmethode /></StripeElements>
                    case Schritt.stripe:
                        return <SchnelleinstiegStripe />
                }
            })()}
        </Container>
    )
}